export default {
    SET_DATA(state, data) {
        state.data = data;
    },
    SET_SEARCH_NAME(state, search_name) {
        state.search_name = search_name;
    },
};
